import { createContext } from "react";
import { Session } from "../api/type";

// Define the context with a specific type
const SessionContext = createContext<Session | null>(null);

export default SessionContext;
